import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Webservice from "../../assets/pic/api.png"
import {Helmet} from "react-helmet";


const WebService = ()=>{
    return(
        <div className="webservice-wrap">
            <Helmet>
                <title>وب سرویس (API) بل میت</title>
                <meta name="description" content="در این بخش مستندات وب سرویس یا همان API های مورد نیاز برای راه اندازی سرویس مورد نظر شرکت ها را می توان مشاهده کرد." />
            </Helmet>
            <Nav/>
            <div className="webservice-dec">
                <h1>مستندات وب سرویس</h1>
                <img src={Webservice} alt=""/>
                <p>
                    جهت استفاده از تمام امکانات سامانه بل میت در اپلیکشین خود می توانید اقدام به استفاده از وب سرویس بل میت فرمایید . وب سرویس به صورت REST می باشد و تمامی درخواست ها به صورت POST بوده و ورودی ها به صورت JSON می باشد که در ادامه توضیح داده خواهد شد .
                </p>
                <br/>
                <p>
                    همچنین توجه داشته باشید که تمامی درخواست ها با HTTP Status Code 200 بازگردانی خواهند شد.
                </p>
                <p>
                    آدرس تمام درخواست ها به صورت زیر خواهد بود :
                </p>
                <pre>
                    <code>
                        https://online.bellmeet.com/api/apiToken
                    </code>
                </pre>
                <p>
                    که کلید سرویس پس از دریافت اکانت در اختیار شما قرار می گیرد.
                </p>
                <h2>نمونه ارسال درخواست :</h2>
                <p>
                    به طور کلی درخواست POST با دیتای JSON به صورت زیر است.
                </p>
                <p>
                    توجه کنید که :
                </p>
                <ul>
                    <li>•	حروف کوچک و بزرگ در تمام قسمت ها متفاوت هستند.</li>
                    <li>•	مقدار "method" همواره String بوده و نام درخواست می باشد  - مثلا getUsers که برای دریافت کاربران می باشد.</li>
                    <li>•	در قسمت "params" هر کدام از "PARAM_*" ها نام پارامتر می باشد و مقدار هر کدام میتواند بر اساس نوع درخواست String - Array - Object باشد.</li>
                </ul>
                <pre>
                    <code>
                        POST https://online.bellmeet.com/api/603e29064544163adsa08bbd2e/b5746e8-fa7a-843-957c-asda465qwed769a
                        {`
 {
    "method": "METHOD_FOR_DO",
    "params": {
                "PARAM_1": "SOME_DATA_1",
                "PARAM_2": "SOME_DATA_2",
                ...
              }
 }
  `}
                    </code>
                </pre>
                <p>
                    پاسخ تمام توابع مورد استفاده شامل عبارت "success" هستند که به صورت Boolean بوده که مشخص کننده نتیجه درخواست می باشد .
                </p>
                <p>
                    همچنین درصورت false بودن "success" فیلد های error"" و "code" خواهند بود که دلیل خطا را مشخص می کنند که در ادامه توضیح داده خواهد شد .
                </p>
                <p>
                    همچنین برای paginate کردن میتوانید به صورت Query Params از فیلتر های page و per_page برای محدود کردن صفحه و تعداد آیتم در هر صفحه استفاده کنید.
                </p>
                <h3>
                    لیست شناسه نقش ها :
                </h3>
                <div className="table-mamad">
                    <table className="ltr table-right" >
                        <thead>
                        <tr>
                            <td>
                                <p><strong>ID</strong></p>
                            </td>
                            <td>
                                <p><strong>Name</strong></p>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <p>4</p>
                            </td>
                            <td>
                                <p>مدیر</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>3</p>
                            </td>
                            <td>
                                <p>استاد</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>2</p>
                            </td>
                            <td>
                                <p>ارائه دهنده</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>1</p>
                            </td>
                            <td>
                                <p>دانش پذیر</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <p>
                    فرایند نمونه برای ایجاد وبینار و استفاده از آن :
                </p>
                <ul>
                    <li>1-	ساخت اتاق</li>
                    <li>2-	ساخت کاربر (ها)</li>
                    <li>3-	دسترسی دادن به کاربران برای استفاده از اتاق ساخته شده</li>
                    <li>4-	دریافت لینک ورود به اتاق</li>
                </ul>
                <br/>
                <h2>لیست توابع قابل استفاده :</h2>
                <br/>
                <h3>1-	دریافت اطلاعات سرویس:</h3>
                <pre>
                    <code>
                        getService
                    </code>
                </pre>
                <p>
                    به وسیله این تابع سرویس حال حاضر شما قابل مشاهده می باشد.
                </p>
                <pre>
                    <code>
                        {`{
     "method":"getService",
     "params":{}
 }`}
                    </code>
                </pre>
                <p>
                    نتیجه درخواست :
                </p>
                <pre>
                    <code>
 {`{
     "success": true,
     "service": {
                    "id": 1,
                    "name": "Free Plan",
                    "display_name": "تست نمایشی",
                    "max_user": 1000,
                    "active": true,
                    "expire_date": 9782946000,
                    "video_limit": 5,
                    "createdAt": "2021-03-02T12:01:15.747Z",
                    "updatedAt": "2021-06-10T08:18:33.673Z"
                }
 }`}
                    </code>
                </pre>
                <p>
                    توضیحات نتیجه :
                </p>
                <table className="ltr table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>display_name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام نمایشی در اتاق</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>ظرفیت کاربران سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>video_limit</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>ظرفیت دوربین همزمان</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>expire_date</p>
                        </td>
                        <td>
                            <p>Unix time</p>
                        </td>
                        <td>
                            <p>تاریخ انقضا</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>وضعیت فعال بودن</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان ایجاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان بروزرسانی</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h2>2-	دریافت اطلاعات همه کاربران:</h2>
                <pre>
                    <code>
                        getUsers
                    </code>
                </pre>
                <p>
                    به وسیله این تابع کاربران سرویس شما قابل مشاهده می باشد.
                </p>
                <pre>
                    <code>
 {`{
        "method":"getUsers",
        "params":{}
  }`}
                    </code>
                </pre>
                <p>
                    نتیجه درخواست :
                </p>
                <pre>
                    <code>
  {`{
    "success": true,
    "users": {
                "docs": [
                            {
                                "id": 34,
                                "username": "testimport6",
                                "name": "test6",
                                "active": true,
                                "createdAt": "2021-06-09T11:10:48.415Z",
                                "updatedAt": "2021-06-09T11:10:48.415Z",
                                "service_name": "Free Plan",
                                "service_id": 1
                            },
                            {
                                "id": 33,
                                "username": "testimport5",
                                "name": "test5",
                                "active": true,
                                "createdAt": "2021-06-09T11:10:48.076Z",
                                "updatedAt": "2021-06-09T11:10:48.076Z",
                                "service_name": " Free Plan ",
                                "service_id": 1
                            }
                        ],
    "totalDocs": 16,
    "limit": 10,
    "totalPages": 2,
    "page": 1,
    "pagingCounter": 1,
    "hasPrevPage": false,
    "hasNextPage": true,
    "prevPage": null,
    "nextPage": 2
            }
}`}
                    </code>
                </pre>
                <p>
                    توضیحات نتیجه :
                </p>
                <table className="ltr table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام کاربری</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_name</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>نام سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>وضعیت فعال بودن</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان ایجاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان بروزرسانی</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>
                    3-	دریافت اطلاعات یک کاربر:
                </h2>
                <pre>
                    <code>
                        getUser
                    </code>
                </pre>
                <p>
                    به وسیله این تابع یک کاربر سرویس شما قابل مشاهده می باشد.
                    <br/>
                    در این تابع می توانید با استفاده از یکی از پارامتر های اختیاری کاربر مورد نظر را دریافت کنید .
                    <br/>
                    پارامتر "id" برای جستجو بر اساس شناسه و "username" بر اساس نام کاربری است . (یکی از دو مورد باید حتما ارسال شود)
                </p>
                <pre>
                    <code>
{`{
\t"method":"getUser",
\t"params":{
\t\t"id" : "ID",
\t\t"username" : "USERNAME"
\t}
 }`}
                    </code>
                </pre>
                <p>
                    توضیحات درخواست :
                </p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام کاربری</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>
                    نتیجه درخواست :
                </p>
                <pre>
                    <code>
{`{
    "success": true,
    "user": {
            "id": 6,
            "username": "bj_5",
            "name": "کاربر جدید",
            "active": true,
            "createdAt": "2021-03-09T10:17:34.703Z",
            "updatedAt": "2021-03-09T10:17:34.703Z",
            "service_name": " Free Plan ",
            "service_id": 1
            }
 }`}
                    </code>
                </pre>
                <p>
                    توضیحات نتیجه :
                </p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام کاربری</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_name</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>نام سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>وضعیت فعال بودن</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان ایجاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان بروزرسانی</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>4-	ساخت کاربر :</h2>
                <pre>
                    <code>createUser</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"createUser",
\t"params":{
\t\t"username":"USERNAEM",
\t\t"password":"PASSWORD",
\t\t"name":"NAME"
\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام کاربری</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>password</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>رمز کاربر</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام کاربر</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "user": {
            "id": 6,
            "username": "bj_5",
            "name": "نام کاربر جدید",
            "active": true,
            "createdAt": "2021-03-09T10:17:34.703Z",
            "updatedAt": "2021-03-09T10:17:34.703Z",
            "service_name": " Free Plan ",
            "service_id": 1
            }
 }
`}
                    </code>
                </pre>
                <p>توضیحات نتیجه :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام کاربری</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_name</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>نام سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>وضعیت فعال بودن</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان ایجاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان بروزرسانی</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>5-	ویرایش کاربر :</h2>
                <pre>
                    <code>editUser</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"editUser",
\t"params":{
\t\t"id":"ID",
\t\t"username":"USERNAEM",
\t\t"password":"PASSWORD",
\t\t"name":"NAME"
\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td >
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                        <td>
                            <p><strong>Default</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>number</p>
                        </td>
                        <td>
                            <p>شناسه کاربر</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام کاربری</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>previous_data</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>password</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>رمز کاربر</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>previous_data</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام کاربر</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>previous_data</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "user": {
            "id": 6,
            "username": "bj_5",
            "name": "کاربر ادیت شده",
            "active": true,
            "createdAt": "2021-03-09T10:17:34.703Z",
            "updatedAt": "2021-03-09T10:17:34.703Z",
            "service_name": " Free Plan ",
            "service_id": 1
            }
 }`}
                    </code>
                </pre>
                <p>توضیحات نتیجه :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام کاربری</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_name</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>نام سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه سرویس</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>وضعیت فعال بودن</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان ایجاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان بروزرسانی</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h2>6-	حذف کاربر :</h2>
                <pre>
                    <code>deleteUser</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"deleteUser",
\t"params":{
                             "id":"ID"
\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>number</p>
                        </td>
                        <td>
                            <p>شناسه کاربر</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <br/>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
 }`}
                    </code>
                </pre>
                <h2>7-	دریافت اطلاعات همه اتاق ها:</h2>
                <pre>
                    <code>getRooms</code>
                </pre>
                <p>به وسیله این تابع اتاق های سرویس شما قابل مشاهده می باشد.</p>
                <pre>
                    <code>
{`{
\t"method":"getRooms",
\t"params":{}
 }`}
                    </code>
                </pre>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "rooms": {
             "docs":[
                     {
                        "id": 18,
                        "name": "101042",
                        "slug": "my-link2",
                        "duration": 0,
                        "max_user": 10,
                        "has_guest": true,
                        "link": "c2c4165e-c0b4-4e40-be23-eabdaaef9844",
                        "active": true,
                        "host_start": false,
                        "redirect_url": "",
                        "createdAt": "2021-06-08T10:44:01.035Z",
                        "updatedAt": "2021-06-10T07:08:24.762Z",
                        "service_name": "Free Plan",
                        "service_id": 1
                     }
                    ],
            "totalDocs": 16,
            "limit": 10,
            "totalPages": 2,
            "page": 1,
            "pagingCounter": 1,
            "hasPrevPage": false,
            "hasNextPage": true,
            "prevPage": null,
            "nextPage": 2
            }
 }`}
                    </code>
                </pre>
                <p>توضیحات نتیجه :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>آدرس اختصاصی</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>زمان اتاق (ثانیه)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>حداکثر تعداد کاربران</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_geust</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>دارای مهمان</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک اتاق</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>شروع توسط استاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک ریدایرکت پس از خروج</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>وضعیت فعال بودن</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان ایجاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان بروزرسانی</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>8-	دریافت اطلاعات یک اتاق:</h2>
                <pre>
                    <code>getRoom</code>
                </pre>
                <p>به وسیله این تابع یک اتاق سرویس شما قابل مشاهده می باشد. </p>
                <pre>
                    <code>
{`{
\t"method":"getRoom",
\t"params":{
\t\t"id" : "ID"
\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "room": 
             {
                "id": 18,
                "name": "101042",
                "slug": "my-link2",
                "duration": 0,
                "max_user": 10,
                "has_guest": true,
                "link": "c2c4165e-c0b4-4e40-be23-eabdaaef9844",
                "active": true,
                "host_start": false,
                "redirect_url": "",
                "createdAt": "2021-06-08T10:44:01.035Z",
                "updatedAt": "2021-06-10T07:08:24.762Z",
                "service_name": "Free Plan",
                "service_id": 1
            }
 }`}
                    </code>
                </pre>
                <p>توضیحات نتیجه :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>آدرس اختصاصی</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>زمان اتاق (ثانیه)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>حداکثر تعداد کاربران</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_geust</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>دارای مهمان</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک اتاق</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>شروع توسط استاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک ریدایرکت پس از خروج</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>وضعیت فعال بودن</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان ایجاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان بروزرسانی</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>9-	ساخت اتاق :</h2>
                <pre>
                    <code>createRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"createRoom",
\t"params":{
\t\t"name":"USERNAEM",
\t\t"duration":"PASSWORD",
\t\t"max_user":"NAME",
\t\t…Optional_Fileds
\t\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                        <td>
                            <p><strong>Default</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام اتاق</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>زمان اتاق (ثانیه)</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>حداکثر ظرفیت کاربران</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_guest</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>دارای مهمان</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>false</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>شروع با استاد</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>false</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک ریدایرکت پس از خروج</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>null</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>آدرس اختصاصی</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>null</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "room": 
             {
                "id": 18,
                "name": "101042",
                "slug": "my-link2",
                "duration": 0,
                "max_user": 10,
                "has_guest": true,
                "link": "c2c4165e-c0b4-4e40-be23-eabdaaef9844",
                "active": true,
                "host_start": false,
                "redirect_url": "",
                "createdAt": "2021-06-08T10:44:01.035Z",
                "updatedAt": "2021-06-10T07:08:24.762Z",
                "service_name": "Free Plan",
                "service_id": 1
             }
 }`}
                    </code>
                </pre>
                <p>توضیحات نتیجه :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>آدرس اختصاصی</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>زمان اتاق (ثانیه)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>حداکثر تعداد کاربران</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_geust</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>دارای مهمان</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک اتاق</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>شروع توسط استاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک ریدایرکت پس از خروج</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>وضعیت فعال بودن</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان ایجاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان بروزرسانی</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>10-	ویرایش اتاق :</h2>
                <pre>
                    <code>editRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"editRoom",
\t"params":{
\t\t"id":"ID",
\t\t"name":"NAME",
\t\t…Other_Fileds
\t\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                        <td>
                            <p><strong>Default</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه اتاق</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام اتاق</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>زمان اتاق (ثانیه)</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>حداکثر ظرفیت کاربران</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_guest</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>دارای مهمان</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>false</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>شروع با استاد</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>false</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک ریدایرکت پس از خروج</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>null</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>آدرس اختصاصی</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>null</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "room": 
             {
                "id": 18,
                "name": "101042-Edited",
                "slug": "my-link2",
                "duration": 0,
                "max_user": 10,
                "has_guest": true,
                "link": "c2c4165e-c0b4-4e40-be23-eabdaaef9844",
                "active": true,
                "host_start": false,
                "redirect_url": "",
                "createdAt": "2021-06-08T10:44:01.035Z",
                "updatedAt": "2021-06-10T07:08:24.762Z",
                "service_name": "Free Plan",
                "service_id": 1
             }
 }`}
                    </code>
                </pre>
                <p>توضیحات نتیجه :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>آدرس اختصاصی</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>زمان اتاق (ثانیه)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>حداکثر تعداد کاربران</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_geust</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>دارای مهمان</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک اتاق</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>شروع توسط استاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک ریدایرکت پس از خروج</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>وضعیت فعال بودن</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان ایجاد</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>زمان بروزرسانی</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h2>11-	حذف اتاق :</h2>
                <pre>
                    <code>deleteRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"deleteRoom",
\t"params":{
\t\t"id":"ID"
\t\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه اتاق</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <br/>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
 }`}
                    </code>
                </pre>
                <h2>توابع دسترسی ها :</h2>
                <br/>
                <h2>1-	افزودن دسترسی کاربر (ها) به اتاق :</h2>
                <pre>
                    <code>addUsersToRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"addUsersToRoom",
\t"params":{
\t\t  "id":"ID",
\t\t  "users":[
\t\t\t  {
\t\t\t  "user":"USER_ID",
\t\t\t  "role":"ROLE_ID"
\t\t\t  },
\t\t\t  {
\t\t\t  "user":"USER_ID2",
\t\t\t  "role":"ROLE_ID2"
\t\t\t  },
\t\t\t  …
\t\t\t  ],
\t\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه اتاق</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>users[ ]</p>
                        </td>
                        <td>
                            <p>Array[object]</p>
                        </td>
                        <td>
                            <p>کاربران دارای دسترسی</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>users[ ].user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه کاربر</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>users[ ].role</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه نقش</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true
 }`}
                    </code>
                </pre>
                <h2>2-	حذف دسترسی کاربر (ها) از اتاق :</h2>
                <pre>
                    <code>removeUsersFromRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"removeUsersFromRoom",
\t"params":{
\t\t"id":"ID",
\t\t"users":[
\t\t\tUSER_ID1,
\t\t\tUSER_ID2,
\t\t\t…
\t\t\t],
\t\t}
}`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه اتاق</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>users[ ]</p>
                        </td>
                        <td>
                            <p>Array[Number]</p>
                        </td>
                        <td>
                            <p>کاربران جهت حذف دسترسی</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>users[item]</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه کاربر</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true
 }`}
                    </code>
                </pre>
                <h2>3-	لیست اتاق های یک کاربر :</h2>
                <pre>
                    <code>getUserRooms</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"getUserRooms",
\t"params":{
\t\t"id":"USER_ID"
\t\t }
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه کاربر</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "rooms": [
            {
            "room_name": "new class",
            "id": 4,
            "role": "admin"
            },
            {
            "room_name": "101042",
            "id": 18,
            "role": "operator"
            },
            …
            ]
 }`}
                    </code>
                </pre>
                <p>توضیحات نتیجه :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>rooms[ ]</p>
                        </td>
                        <td>
                            <p>Array[object]</p>
                        </td>
                        <td>
                            <p>لیست اتاق های کاربر</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>rooms[ ].room_name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام اتاق</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>rooms[ ].id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه اتاق</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>rooms[ ].role</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>نام نقش کاربر</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>4-	لیست کاربر های یک اتاق :</h2>
                <pre>
                    <code>getRoomUsers</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"getRoomUsers",
\t"params":{
\t\t"id":"ROOM_ID"
\t\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه اتاق</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "users": {
            "docs": [
                    {
                    "id": 5,
                    "username": "bj_4",
                    "name": "کاربر",
                    "active": true,
                    "createdAt": "2021-03-06T21:00:09.267Z",
                    "updatedAt": "2021-06-15T06:21:15.586Z",
                    "service_name": "Free Plan",
                    "service_id": 1,
                    "role": {
                            "name": "operator",
                            "id": 3
                            }
                    }
                    ],
            "totalDocs": 1,
            "limit": 10,
            "totalPages": 1,
            "page": 1,
            "pagingCounter": 1,
            "hasPrevPage": false,
            "hasNextPage": false,
            "prevPage": null,
            "nextPage": null
            } 
 }`}
                    </code>
                </pre>
                <h2>5-	دریافت لینک ورود به اتاق :</h2>
                <p>پس از اضافه کردن دسترسی کاربر حال میتوانید لینک ورود مستقیم کاربر را از طریق این تابع دریافت کنید .</p>
                <pre>
                    <code>getLink</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"getLink",
\t"params":{
\t\t"room":"ROOM_ID",
\t\t"user":"USER_ID",
\t\t"ttl":"TIME_TO_LIVE",
\t\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                        <td>
                            <p><strong>Default</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>room</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه اتاق</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه کاربر</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>ttl</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>اعتبار لینک (ثانیه)</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>3600</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "link": "https://online.bellmeet.com/r/18/5-4aeb8c10-cda9-11eb-adf1-29d6896ec3c7-OiQlZt3CZZ6tI4VgpoIpHbfh87YhsTMzi33CwvQR9Q0RRFQOhvMDv3QWN6eBsrQw" 
 }`}
                    </code>
                </pre>
                <p>توضیحات نتیجه :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک مستقیم ورود</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h2>6- دریافت لینک مستقیم ورود به اتاق برای مهمان :</h2>
                <p>شما میتوانید مستقیما مهمانی رو به اتاق با دسترسی مدنظر خود وارد کنید که نیازی به ساخت کاربر نمی باشد.</p>
                <pre>
                    <code>getGuestLink</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"getGuestLink",
\t"params":{
\t\t"room":"ROOM_ID",
\t\t"user":{
\t\t\t"name":"GUEST_NAME",
\t\t\t"role":"GUEST_ROLE_ID"
\t\t},
\t\t"ttl":"TIME_TO_LIVE",
\t\t}
 }`}
                    </code>
                </pre>
                <p>توضیحات درخواست :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                        <td>
                            <p><strong>Default</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>room</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>شناسه اتاق</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>user</p>
                        </td>
                        <td>
                            <p>Object</p>
                        </td>
                        <td>
                            <p>کاربر</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Object</p>
                        </td>
                        <td>
                            <p>نام مهمان</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>role</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>دسترسی مهمان</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>1</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>ttl</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>اعتبار لینک (ثانیه)</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>3600</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <p>نتیجه درخواست :</p>
                <pre>
                    <code>
{`{
    "success": true,
    "link": "https://online.bellmeet.com/r/18/5-4aeb8c10-cda9-11eb-adf1-29d6896ec3c7-OiQlZt3CZZ6tI4VgpoIpHbfh87YhsTMzi33CwvQR9Q0RRFQOhvMDv3QWN6eBsrQw" 
 }`}
                    </code>
                </pre>
                <p>توضیحات نتیجه :</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>لینک مستقیم ورود</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <Footer/>
        </div>
    )
}

export default WebService